export const TARIFF_CARD_GAP_PX = 50;
export const TARIFF_CARDS_SCROLL_PADDING_X = 50;

export const DURATION_MULTIPLIERS: Record<string, number> = {
  '30': 1,
  '60': 2,
  '90': 3,
  '180': 6,
};
